'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const jstz=require('jstimezonedetect');

const USIanaTimeZones=[
'America/New_York',
'America/Detroit',
'America/Kentucky/Louisville',
'America/Kentucky/Monticello',
'America/Indiana/Indianapolis',
'America/Indiana/Vincennes',
'America/Indiana/Winamac',
'America/Indiana/Marengo',
'America/Indiana/Petersburg',
'America/Indiana/Vevay',
'America/Chicago',
'America/Indiana/Tell_City',
'America/Indiana/Knox',
'America/Menominee',
'America/North_Dakota/Center',
'America/North_Dakota/New_Salem',
'America/North_Dakota/Beulah',
'America/Denver',
'America/Boise',
'America/Phoenix',
'America/Los_Angeles',
'America/Anchorage',
'America/Juneau',
'America/Sitka',
'America/Metlakatla',
'America/Yakutat',
'America/Nome',
'America/Adak',
'Pacific/Honolulu'];let


TimeZoneService=function(_BaseService){_inherits(TimeZoneService,_BaseService);_createClass(TimeZoneService,null,[{key:'$inject',get:function()
{return[]}}]);

function TimeZoneService(){_classCallCheck(this,TimeZoneService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this.__actualLocalTimeZone=jstz.determine().name();

_this.reset();return _this;
}TimeZoneService.prototype.

reset=function reset(){
this._localTimeZone=this.__actualLocalTimeZone;
};TimeZoneService.prototype.

setMockTimeZone=function setMockTimeZone(timeZone){
this._localTimeZone=timeZone;
};_createClass(TimeZoneService,[{key:'isMocked',get:function()

{
return this._localTimeZone!==this.__actualLocalTimeZone;
}},{key:'localTimeZone',get:function()

{
return this._localTimeZone;
}},{key:'USIanaTimeZones',get:function()

{
return USIanaTimeZones;
}}]);return TimeZoneService}(BaseService);


module.exports=TimeZoneService;
//# sourceMappingURL=timeZoneService.js.map
